<script setup lang="ts">
import { isPbAccountIframeEnabled } from '~/utils/pbAccountIframeFeature'

definePageMeta({
  layout: 'page'
})

const runtimeConfig = useRuntimeConfig()
const publicConfig = runtimeConfig?.public

if (!isPbAccountIframeEnabled(publicConfig)) {
  throw createError({ statusCode: 404, statusMessage: 'Page not found!' })
}

const {
  iframeID,
  initializePulseBlazorIframe
} = usePulseBlazorIframe()

let pageAlive = true
let cancelPulseIframeInit = () => {}

onMounted(async () => {
  const cancel = await initializePulseBlazorIframe()
  if (!pageAlive) {
    cancel()
    return
  }
  cancelPulseIframeInit = cancel
})

onBeforeUnmount(() => {
  pageAlive = false
  cancelPulseIframeInit()
})
</script>

<template>
  <section class="pb-account-shell" aria-label="Pulse My Account host page">
    <iframe
      :id="iframeID"
      :name="iframeID"
      allow="clipboard-read *; clipboard-write *"
      scrolling="no"
      class="pb-account-shell__iframe"
    />
  </section>
</template>

<style lang="scss" scoped>
.pb-account-shell {
  width: 100%;
}

.pb-account-shell__iframe {
  display: block;
  width: 100%;
  height: 500px;
  min-height: 500px;
  border: 0;
}
</style>
